import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { ChevronLeft, ChevronRight } from "../../icons";
import { Button, InputText } from "./..";

import { INPUT_OPTIONS_SIZES } from "../../utils/forms";
import { useDebounce } from "../../hooks/useDebounce";
import useFirstRender from "../../hooks/useFirstRender";
import { createStyles } from "./styles";

var Table = function Table(props) {var _pagination$minPage, _pagination$maxPage, _context;
  var children = props.children,className = props.className,pagination = props.pagination,id = props.id,paginationControllerClassName = props.paginationControllerClassName;
  // Common data
  var minimalPage = (_pagination$minPage = pagination === null || pagination === void 0 ? void 0 : pagination.minPage) !== null && _pagination$minPage !== void 0 ? _pagination$minPage : 1;
  var maxPage = (_pagination$maxPage = pagination === null || pagination === void 0 ? void 0 : pagination.maxPage) !== null && _pagination$maxPage !== void 0 ? _pagination$maxPage : 1;

  // React refs
  var prevPageRef = useRef(null);

  // React state
  var _useState = useState((pagination === null || pagination === void 0 ? void 0 : pagination.tablePage) || minimalPage),_useState2 = _slicedToArray(_useState, 2),currentPage = _useState2[0],setCurrentPage = _useState2[1];
  var _useState3 = useState((pagination === null || pagination === void 0 ? void 0 : pagination.tablePage) || minimalPage),_useState4 = _slicedToArray(_useState3, 2),searchPage = _useState4[0],setSearchPage = _useState4[1];
  var debouncedValue = useDebounce(searchPage, 250);
  var firstRender = useFirstRender();

  var isSearchPageValid = searchPage <= maxPage && searchPage >= minimalPage;

  // Component actions
  function increaseNumber() {
    setCurrentPage(function (prevVal) {
      if (pagination && maxPage) {
        return prevVal >= maxPage ? prevVal : prevVal + 1;
      }
      return prevVal + 1;
    });
  }

  function decreaseNumber() {
    setCurrentPage(function (prevVal) {
      return prevVal <= minimalPage ? prevVal : prevVal - 1;
    });
  }

  var updatePage = function updatePage(page) {
    if (prevPageRef.current !== page) {
      if (pagination !== null && pagination !== void 0 && pagination.onPageChange) {
        pagination.onPageChange(page);
      }
      prevPageRef.current = page;
    }
  };

  // React effects
  // Call the callback right after the currentPage has changed.
  useEffect(function () {
    updatePage(currentPage);
    if (pagination !== null && pagination !== void 0 && pagination.showPageInput) {
      setSearchPage(currentPage);
    }
  }, [currentPage]);

  useEffect(function () {
    if (!firstRender && pagination !== null && pagination !== void 0 && pagination.showPageInput && isSearchPageValid) {
      updatePage(debouncedValue);
      setCurrentPage(searchPage);
    }
  }, [debouncedValue]);

  useEffect(function () {
    if (maxPage && currentPage > maxPage) {
      setCurrentPage(maxPage);
    }
  }, [maxPage]);

  useEffect(function () {
    if (pagination !== null && pagination !== void 0 && pagination.tablePage && (pagination === null || pagination === void 0 ? void 0 : pagination.tablePage) !== currentPage) {
      setCurrentPage(pagination === null || pagination === void 0 ? void 0 : pagination.tablePage);
    }
  }, [pagination === null || pagination === void 0 ? void 0 : pagination.tablePage]);

  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("div", { className: classes.tableWrapper }, /*#__PURE__*/
    React.createElement("table", { className: clsx(classes.table, className), role: "grid", id: "table-".concat(id) },
    children),

    pagination && /*#__PURE__*/
    React.createElement("div", {
      className: clsx(
      pagination.showPageInput && classes.paginationWrapper,
      paginationControllerClassName) },


    pagination.showPageInput && /*#__PURE__*/
    React.createElement("div", { className: classes.inputPageWrapper }, /*#__PURE__*/
    React.createElement("p", { className: classes.inputTitle }, "Go to page"), /*#__PURE__*/
    React.createElement(InputText, {
      value: String(searchPage),
      htmlType: "number",
      onChange: function onChange(e) {return setSearchPage(+e.target.value);},
      width: INPUT_OPTIONS_SIZES.small,
      validationPassed: isSearchPageValid,
      validationMessage: "Incorrect page number",
      className: classes.inputPage })), /*#__PURE__*/



    React.createElement("div", { className: classes.paginationController }, /*#__PURE__*/
    React.createElement(Button, { type: "icon", color: "primary", onClick: decreaseNumber, id: "pagination-left" }, /*#__PURE__*/
    React.createElement(ChevronLeft, { width: "2.4rem" })), /*#__PURE__*/

    React.createElement("div", { className: classes.pageNumbers, id: "pagination-page" }, _concatInstanceProperty(_context = "".concat(
    currentPage, " / ")).call(_context, maxPage)), /*#__PURE__*/

    React.createElement(Button, { type: "icon", color: "primary", onClick: increaseNumber, id: "pagination-right" }, /*#__PURE__*/
    React.createElement(ChevronRight, { width: "2.4rem" }))))));






};
Table.displayName = 'Table';

export default Table;
//# sourceMappingURL=index.js.map